import { request } from "services/api/util";

class ResourceMasterService {
  async _getDetail(storeCode, id, resourceType,{ year, month } = {}) {
    const config = {
      method: "get",
      url: `admin/store/${storeCode}/${resourceType}/${id}`,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };

    if (Number.isInteger(year) || Number.isInteger(month)) {
      config.params = {};
      if (Number.isInteger(year))  config.params.year  = year;
      if (Number.isInteger(month)) config.params.month = month;
    }

    return request(config);
  }

  async getDetailRoom(storeCode, id,opts = {}) {
    return this._getDetail(storeCode, id, "rooms", opts);
  }

  async getDetailStaff(storeCode, id,opts = {}) {
    return this._getDetail(storeCode, id, "staffs",opts);
  }

  async _createResource(storeCode, body, resourceType) {
    const config = {
      method: "post",
      url: `admin/store/${storeCode}/${resourceType}`,
      data: body,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createRoom(storeCode, body) {
    return this._createResource(storeCode, body, "rooms");
  }

  async createStaff(storeCode, body) {
    return this._createResource(storeCode, body, "staffs");
  }

  async _updateResource(storeCode, id, body, resourceType) {
    const config = {
      method: "put",
      url: `admin/store/${storeCode}/${resourceType}/${id}`,
      data: body,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateRoom(storeCode, id, body) {
    return this._updateResource(storeCode, id, body, "rooms");
  }

  async updateStaff(storeCode, id, body) {
    return this._updateResource(storeCode, id, body, "staffs");
  }
}

export default new ResourceMasterService();
